module.exports = __webpack_public_path__ + "media/images/logo_pix-90f1562c585dc33f59143debc0b3570f.svg";